// extracted by css-extract-rspack-plugin
export default {"cls1":"LandingScreen-cls1_77f","cls2":"LandingScreen-cls2_SRs LandingScreen-cls1_77f"};